<template>
  <v-navigation-drawer
    id="core-navigation-drawer"
    v-model="drawer"
    :dark="barColor !== 'rgba(228, 226, 226, 1), rgba(255, 255, 255, 0.7)'"
    :expand-on-hover="expandOnHover"
    :right="$vuetify.rtl"
    :src="barImage"
    mobile-breakpoint="960"
    app
    width="260"
    v-bind="$attrs"
    mini-variant-width="80"
  >
    <template v-slot:img="props">
      <v-img
        :gradient="`to bottom, ${barColor}`"
        v-bind="props"
      />
    </template>

    <v-divider class="mb-1"/>

    <v-list
      dense
      nav
    >
      <v-list-item>
        <v-list-item-avatar
          class="align-self-center"
          color="white"
          contain
        >
          <v-img
            :src="logoImg"
            max-height="30"
            contain
          />
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title
            class="headline companyName"
            v-text="profile.title"
          />
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-divider class="mb-2"/>

    <v-list
      expand
      nav
    >
      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div/>

      <template v-for="(item, i) in computedItems">
        <base-item-group
          v-if="item.children"
          :key="`group-${i}`"
          :item="item"
        >
          <!--  -->
        </base-item-group>

        <base-item
          v-else
          :key="`item-${i}`"
          :item="item"
        />
      </template>

      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div/>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
  // Utilities
  import {
    mapState,
  } from 'vuex'
  import store from "@/store";

  export default {
    name: 'DashboardCoreDrawer',

    props: {
      expandOnHover: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      logoImg: require('@/assets/logo.png'),
      items: [
        {
          icon: 'mdi-account-box-multiple',
          title: 'Клиенты',
          roles: ['Administrator', 'ClientManager', 'Executor'],
          to: '/pages/client/list',
        },
        {
          icon: 'mdi-account-box-multiple',
          title: 'Обращения',
          roles: ['Administrator', 'ClientManager'],
          to: '/pages/client/ticket/list',
        },
        {
          icon: 'mdi-forum',
          title: 'Чаты',
          roles: ['Administrator', 'ClientManager'],
          to: '/pages/chat_list',
        },
        {
          icon: 'mdi-calendar-check-outline',
          title: 'Общие заявки',
          roles: ['Administrator', 'ClientManager', 'Executor'],
          to: '/pages/service/list',
        },
        {
          icon: 'mdi-calendar-check-outline',
          title: 'Открытые заявки',
          roles: ['Executor'],
          to: '/pages/executor/service/unassigned/list',
        },
        {
          icon: 'mdi-calendar-check-outline',
          title: 'Мои заявки',
          roles: ['Executor'],
          to: '/pages/executor/service/assigned/list',
        },
        {
          icon: 'mdi-book-open-page-variant',
          title: 'База знаний',
          roles: ['Administrator', 'ClientManager', 'Executor'],
          to: '/pages/knowledgebase/list',
        },
        {
          icon: 'mdi-book-alphabet',
          title: 'Справочники',
          roles: ['Administrator'],
          group: '/pages/dictionary',
          children: [
            {
              icon: 'mdi-graph-outline',
              title: 'Отделы',
              to: 'department',
            },
            {
              icon: 'mdi-domain',
              title: 'Компании',
              to: 'company',
            },
            {
              icon: 'mdi-numeric-1-box-multiple-outline',
              title: 'Серии номеров',
              to: 'series_number',
            },
            {
              icon: 'mdi-format-list-bulleted-type',
              title: 'Типы заявок',
              to: 'service_type',
            },
            {
              icon: 'mdi-text-box-check',
              title: 'Типы лицензий',
              to: 'license_type',
            },
            {
              icon: 'mdi-face-agent',
              title: 'Типы обслуживания',
              to: 'client_service_type',
            },
            {
              icon: 'mdi-laptop-chromebook',
              title: 'Версии iiko',
              to: 'software_version_type',
            },
            {
              icon: 'mdi-priority-high',
              title: 'Важность заявок',
              to: 'service_importance',
            },
            {
              icon: 'mdi-cash-multiple',
              title: 'Выезд',
              to: 'service_visit_type',
            },
            {
              icon: 'mdi-clipboard-account',
              title: 'Должности',
              to: 'position_type',
            },
            {
              icon: 'mdi-file-document-multiple-outline',
              title: 'Типы документов',
              to: 'document_type',
            },
          ]
        },
        {
          icon: 'mdi-tune',
          title: 'Настройки',
          roles: ['Administrator'],
          to: '/pages/settings',
        },
        {
          icon: 'mdi-account-supervisor',
          title: 'Пользователи',
          roles: ['Administrator'],
          to: '/pages/users',
        }
        // {
        //   icon: 'mdi-account',
        //   title: 'user',
        //   to: '/pages/user',
        // },
        // {
        //   title: 'rtables',
        //   icon: 'mdi-clipboard-outline',
        //   to: '/tables/regular-tables',
        // },
        // {
        //   title: 'typography',
        //   icon: 'mdi-format-font',
        //   to: '/components/typography',
        // },
        // {
        //   title: 'icons',
        //   icon: 'mdi-chart-bubble',
        //   to: '/components/icons',
        // },
        // {
        //   title: 'google',
        //   icon: 'mdi-map-marker',
        //   to: '/maps/google-maps',
        // },
        // {
        //   title: 'notifications',
        //   icon: 'mdi-bell',
        //   to: '/components/notifications',
        // },
      ],
    }),

    computed: {
      ...mapState(['barColor', 'barImage']),
      drawer: {
        get() {
          return this.$store.state.drawer
        },
        set(val) {
          this.$store.commit('SET_DRAWER', val)
        },
      },
      computedItems() {
        // return this.items.filter((item) => !item.roles || ).map(this.mapItem)
        return this.items.map(this.mapItem).filter((item) => item.title)
      },
      profile() {
        return {
          avatar: true,
          title: this.$vuetify.lang.t('$vuetify.companyName'),
        }
      },
    },

    methods: {
      mapItem(item) {
        if(item.roles){
          if(store.getters.hasRole(item.roles)){
            return this._mapItem(item)
          } else {
            return []
          }
        }
        else {
          return this._mapItem(item)
        }
      },
      _mapItem(item){
        return {
          ...item,
          children: item.children ? item.children.map(this.mapItem) : undefined,
          title: this.$vuetify.lang.t(item.title),
        }
      }
    },
  }
</script>

<style lang="sass">
  @import '~vuetify/src/styles/tools/_rtl.sass'

  .companyName
    line-height: initial !important

  #core-navigation-drawer
    .v-list-group__header.v-list-item--active:before
      opacity: .24

    .v-list-item
      &__icon--text,
      &__icon:first-child
        justify-content: center
        text-align: center
        width: 20px

        +ltr()
          margin-right: 24px
          margin-left: 12px !important

        +rtl()
          margin-left: 24px
          margin-right: 12px !important

    .v-list--dense
      .v-list-item
        &__icon--text,
        &__icon:first-child
          margin-top: 10px

    .v-list-group--sub-group
      .v-list-item
        +ltr()
          padding-left: 8px

        +rtl()
          padding-right: 8px

      .v-list-group__header
        +ltr()
          padding-right: 0

        +rtl()
          padding-right: 0

        .v-list-item__icon--text
          margin-top: 19px
          order: 0

        .v-list-group__header__prepend-icon
          order: 2

          +ltr()
            margin-right: 8px

          +rtl()
            margin-left: 8px
</style>
